import React, { Component, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { fixedModelImgs } from '../../images/topicImg'

function FixedNavigationModel(props){
  const onMeiQiaCustomer = () => {
    window._MEIQIA('showPanel');
  }
  const { itemsData } = props;
  const UniversalData = [
    { id: 1, title: '报名', icon: fixedModelImgs.side_signup, url: '', },
    { id: 2, title: '售后', icon: fixedModelImgs.side_aftesale, url: '' },
    { id: 3, title: '购物车', icon: fixedModelImgs.side_shopping, url: '' }
  ];
  const [showBackTop, setShowBackTop] = useState(false);

  const handleScroll = () => {
    let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    setShowBackTop(scrollTop > 580);
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, true);
  }, [])

  const backTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  return (
    <div className="topic-fixed-navigation-model">
      <div className='fixed_top_box'>
        {/* 客服热线 */}
        <div className='customer_tel_box'>
          <div className='tel_title'>客服热线</div>
          <div className='tel_text'>173 7581 3702</div>
        </div>
        {/* 报名 售后 购物车 */}
        <div className='universal_box'>
          {UniversalData && UniversalData.map(item => <div className='universal_item flex_row' key={item.id} onClick={onMeiQiaCustomer}>
            <img className='item_icon' src={item.icon} alt=""/>
            <div>{item.title}</div>
          </div>)}
        </div>
      </div>
      <div className='fixed_section_box'>
        {itemsData && itemsData.map(item => <a className='section_fixed_item flex_row' href={item.href} key={item.id}>
          {item.title}
        </a>)}
        {showBackTop && <div className='section_fixed_item flex_row' onClick={() => backTop()}>
          <img src={fixedModelImgs.side_return} alt="" />
        </div>}
      </div>
    </div>
  );
}
FixedNavigationModel.propTypes = {
  topic: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FixedNavigationModel);



// WEBPACK FOOTER //
// ./src/features/topic/FixedNavigationModel.js